import React, { useEffect, useState } from "react";
import "./RedirectNotice.scss";

const REDIRECT_URL = "https://merchant.brisque.com/";
const COUNTDOWN_SECONDS = 5;

const RedirectNotice: React.FC = () => {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const timeout = setTimeout(() => {
      window.location.replace(REDIRECT_URL);
    }, COUNTDOWN_SECONDS * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="redirect-notice">
      <div className="redirect-notice__card">
        <h1 className="redirect-notice__title">Maghil is now Brisque</h1>
        <p className="redirect-notice__message">
          We have upgraded your experience.
        </p>
        <p className="redirect-notice__message">
          Redirecting to your new portal:{" "}
          <a href={REDIRECT_URL} className="redirect-notice__link">
            {REDIRECT_URL}
          </a>
        </p>

        <div className="redirect-notice__timer">
          Redirecting in <span className="redirect-notice__count">{secondsLeft}</span>{" "}
          second{secondsLeft === 1 ? "" : "s"}…
        </div>
      </div>
    </div>
  );
};

export default RedirectNotice;
